import React from 'react';

function Redirecionar({to}){
	window.location.replace(to);
	
    return (<div></div>)
}

export default Redirecionar;
